import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isUndefined, isFunction } from 'lodash';

class MapSidebar extends Component {
	shouldComponentUpdate = () => (true)

	handlePagination = (direction) => (event) => {
		const { handleOnPaginate } = this.props;

		if (!isUndefined(handleOnPaginate) && isFunction(handleOnPaginate)) handleOnPaginate(direction, event);
	}

	render() {
		const {
			totalCount,
			displayCount,
			pageNumber,
			children,
			loading,
			isEmptyList,
		} = this.props;
		const totalPages = Math.ceil(totalCount / displayCount);

		return (
			<div className="map-sidebar">
				<div className="jobs-list-container">
					<div
						className={classNames('jobs-list', {
							empty : isEmptyList,
						})}
					>
						{ children }
						<If condition={isEmptyList && !loading}>
							<p>No data</p>
						</If>
						<If condition={loading}>
							<p>Loading data...</p>
						</If>
						<div className={classNames({ hidden : (totalCount <= displayCount) || loading }, 'text-center')}>
							<ul className="pagination">
								<li className={classNames({ disabled : pageNumber === 1 })}>
									<button className="btn btn-link" type="button" onClick={this.handlePagination('prev')}>
										Previous
									</button>
								</li>
								<li className={classNames({ disabled : pageNumber === totalPages })}>
									<button className="btn btn-link" type="button" onClick={this.handlePagination('next')}>
										Next
									</button>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

MapSidebar.propTypes = {
	children         : PropTypes.any,
	displayCount     : PropTypes.number,
	handleOnPaginate : PropTypes.func,
	isEmptyList      : PropTypes.bool,
	loading          : PropTypes.bool,
	pageNumber       : PropTypes.number,
	totalCount       : PropTypes.number,
};

MapSidebar.defaultProps = {
	children         : undefined,
	displayCount     : 0,
	handleOnPaginate : undefined,
	isEmptyList      : false,
	loading          : false,
	pageNumber       : 0,
	totalCount       : 0,
};

export default MapSidebar;
